<div class="dashboard">
  
  <div class="profile">
  <app-cp-member-profile  [noNomineeAdded]="noNomineeAdded" style="width: 100%"></app-cp-member-profile>
  </div>
  <div class="dependents">
    <app-cp-member-enrollment  class="web-w-50"></app-cp-member-enrollment>
    <app-cp-nominee-enroll  (noNominee)="showAddNomineeBaner($event)" class="web-w-50"></app-cp-nominee-enroll>
  </div>
  <div class="forms">
    <app-download-forms ></app-download-forms>
  </div>
  <div class="contact-us">
    <div class="row">
      <img src="../../../assets/images/contact-us-icon.svg" style="margin-left: 16px;" alt="">
      <div>
        <div>Reach out to us</div>
        <div>
          Raise a query or request assistance anytime.
        </div>
      </div>
    </div>
    <div>
      <button (click)="redirectToContactUs()" >Contact Us</button>
    </div>
  </div>
  <div class="faqs">
    <app-faq style="width: 100%"></app-faq>
  </div>

  <div class="start-tarack-claim-wrapper"  (click)="navigateToClaims()">
    <div class="button-text">Start or Track a Claim</div>
  </div>
</div>